import request from '@/utils/request'
import {API} from './apiConfig'

export function getConferenceDetail(codeId = '') {
	return request({
		url: API.getConferenceDetail,
		method: 'get',
		params: {
			codeId
		},
	})
}

export function submitConferenceScore(codeId = '', grade = '') {
	return request({
		url: API.conferenceScore,
		method: 'post',
		params: {
			codeId,
			grade
		},
	})
}
export function recordConferenceTime(data) {
	return request({
		url: API.recordConferenceTime,
		method: 'post',
		params:data
	})
}
export function submitConferenceExam(answers = [], codeId = '', is4Twice = false) {
	return request({
		url: API.submitConferenceExam,
		method: 'post',
		data: {
			answers,
			codeId,
			is4Twice
		},
	})
}
export function onReceiveConferenceExamGift(codeId = '') {
	return request({
		url: API.onReceiveConferenceExamGift,
		method: 'post',
		params: {
			codeId
		},
	})
}
export function receiveConferenceGift(giftId, codeId) {
	return request({
		url: API.receiveConferenceGift,
		method: 'post',
		params: {
			giftId,
			codeId
		},
	})
}

export function getSceneCommentList({sceneId = '',sceneType = 1, page = 1, pageSize= 20,onlySelf = 0}) {
	return request({
		url: API.publicCommentList,
		method: 'get',
		params: {
			sceneId,
			sceneType,
			pageSize,
			page,
			onlySelf
		}
	})
}
export function getConferenceKnowledgeList(meetingId, pageNo = 1, pageSize = 20) {
	return request({
		url: API.conferenceKnowledgeList,
		method: 'get',
		params: {
			meetingId,
			pageNo,
			pageSize
		},
	})
}
export function onSubmitComment({sceneId='',content='',sceneType = 1,codeId=''}) {
	return request({
		url: API.onCommentScene,
		method: 'post',
		params: {
			sceneId,
			content,
			sceneType,
			codeId
		},
	})
}
export function getKnowledgeDetail(knowledgeId = '') {
	return request({
		method: 'get',
		url: API.KnowledgeDetail,
		params: {
			knowledgeId: knowledgeId
		}
	})
}
export function getCommentReplyList(id) {
	return request({
		method: 'get',
		url: API.getCommentReplyList,
		params: {
			parentCommentId: id,
			page: 1,
			// pageSize: 50
		}
	})
}
